import restart_icon from 'assets/reset_svg.svg';
import styled from "styled-components";

const AdminTopPanel = (props) => {
  const { game, dialog, setIsResetDialogModalOpen } = props;


  return (
    <TopPanelPlaceholder>
      <TopPanelInnerPlaceholder className={'flex flex-row items-center'}>
        <div>
          <InnerTopNamePlaceholder>{game?.publicName}</InnerTopNamePlaceholder>
          <div className={'py-2'}>
            {`Revision: `}
            <span className={'rounded bg-purple-300 px-2 py-2'}>
              {`${dialog?.scenarioRevision}`}
            </span>
          </div>
        </div>
        <div className={'flex flex-1 flex-row items-center justify-end'}>
          <img
            src={restart_icon}
            className={' mr-2 h-8 cursor-pointer opacity-75 hover:opacity-95'}
            id={'reset_icon'}
            onClick={() => setIsResetDialogModalOpen(true)}
          />
        </div>
      </TopPanelInnerPlaceholder>
    </TopPanelPlaceholder>
  );
};

export default AdminTopPanel;

const InnerTopNamePlaceholder = styled.div`
  font-size: 20px;
  line-height: 24px;
  font-weight: bold;
`;

const TopPanelPlaceholder = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  padding-right: 10px;

  color: white;
  font-family: 'Nunito Sans';
  font-size: 16px;
  border-radius: 0px 0px 8px 8px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  z-index: 100;
  background: rgba(10, 5, 44, 1);
`;

const TopPanelInnerPlaceholder = styled.div`
  width: 100%;
  height: 60px;
  @media (max-width: 720px) {
    height: 40px;
  }
  @media (max-width: 480px) {
    height: 40px;
  }
`;
